import React, { useRef } from "react";
import { Divider, Form, Input, Modal, Space, InputNumber, Select, Col, Row } from "antd";
import { PRIMARY_COLOR, SUCCESS_COLOR } from "../../constants/color";
import { theme } from 'antd';
import ColorButton from "../../common/ColorButton";
import {
  MinusCircleOutlined,
  PlusOutlined,
  SearchOutlined
} from '@ant-design/icons';
import { LAB_ORDER_TYPE, LAB_ORDER_TYPE_TH } from "../../constants/string";
import _ from "lodash";
import { URL_CHEMICAL, URL_EMPLOYEE, URL_POND, URL_TANK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import { GET } from "../../frameworks/HttpClient";
import { CHEMICAL } from "../../constants/chemical";
import { useParams } from "react-router-dom";
import ConfirmLabResultsModal from "./ConfirmLabResultsModal";
import { useUserContext } from "../../hooks/UserSettingProvider";

export default function LabResultsModal(props) {
  const { open, onClose, target, onUpdate } = props;
  const params = useParams();
  const [form] = Form.useForm();
  const [formWeight] = Form.useForm();
  const isCreate = (target && target.id ? false : true)
  const { features } = useUserContext();
  const employeeConfig = _.get(features, 'employee_feature', false)
  const [errorMessages, setErrorMessages] = React.useState(null);
  const [employee, setEmployee] = React.useState(null);
  const [widthModal , setwidthModal] = React.useState(900);
  const [chemical, setChemical] = React.useState([]);
  const [additionalChemical, setAdditionalChemical] = React.useState([]);
  const [resultsConfirmData ,setResultsConfirmData] = React.useState(null);
  const pinRef = useRef(null);
  const weightWatch = Form.useWatch('original_weight', formWeight)
  // const [tankChemical, setTankChemical] = React.useState([]);

  const fetchChemical = async() => {
    try {
      const response = await GET(URL_CHEMICAL.QUALITY_CHEMICAL)
      setChemical(response.data.results)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const handleOk = async() => {
    setErrorMessages(null);
    try {
      // prepare Data
      const formData = await form.validateFields();
      const result = [
        ..._.get(formData, 'main', []).map((item) => {
        return({chemical : item.chemical, amount : item.amount ?? 0})
      })]

      const fill_latex = [
        ..._.get(formData, 'fill', []).map((item) => {
        return({chemical : item.name, amount : item.amount ?? 0})
      })
      , ..._.get(formData, 'fill_more', [])]

      // check validate result
      const checkedConditionResults = _.filter(result , (item) => item.amount !== 0)
      // if(checkedConditionResults.length === 0 && (_.get(target, 'type', null) === LAB_ORDER_TYPE.TRUCK || _.get(target, 'type', null) === LAB_ORDER_TYPE.SKIM)){
      //   throw new Error("กรุณากรอกผลแล็บ");
      // }
      const checkedConditionFill = _.filter(fill_latex , (item) => item.amount !== 0)

      const data = {
        results : checkedConditionResults,
        inputs : checkedConditionFill,
        lab_employee : employee ? employee.id : null
      }

      if(employeeConfig && !data['lab_employee']){
        throw new Error("กรุณาใส่ Pin พนักงาน");
      }
      if(isCreate){
        const formWeightData = await formWeight.validateFields();
        // await POST(URL_LAB.LAB_ORDER, {
        //   ...data,
        //   ...formWeightData, 
        //   ref : (params.role === LAB_ORDER_TYPE.POND && params.role === LAB_ORDER_TYPE.LAB_POND) ? `${URL_POND.POND_TRANSACTION}${params.id}/` :  `${URL_TANK.TANK_TRANSACTION}${params.id}/`
        // })
        // onUpdate();
        setResultsConfirmData({
          ...data,
          ...formWeightData, 
          ref : (params.role === LAB_ORDER_TYPE.POND || params.role === LAB_ORDER_TYPE.LAB_POND) ? `${URL_POND.POND_TRANSACTION}${params.id}/` :  `${URL_TANK.TANK_TRANSACTION}${params.id}/`
        })
      } else {
        setResultsConfirmData(data)
        // await POST(`${URL_LAB.LAB_ORDER}${target.id}/lab/`, data)
        // onUpdate();
      }
    } catch (error) {
      setErrorMessages(_.get(error, error.message ? 'message' : 'errorMessages' , null));
    }
  }

  const handleValidateEmployee = async(pin) => {
    setEmployee(null);
    try {
      const response = await GET(`${URL_EMPLOYEE.VERIFY_EMPLOYEE}${pin}/`)
      setEmployee(response.data)
    } catch (error) {
      setErrorMessages (error.setErrorMessages);
    }
  }

  const {
    token: { colorError },                                                                         
  } = theme.useToken();
  
  React.useEffect(() => {
    if(target){
      form.resetFields();
      formWeight.setFieldsValue({
        original_weight : target.current_weight,
        original_height : target.current_height 
      })
      console.log(target)
    } else {
      setEmployee(null);
    }

  },[target])

  React.useEffect(() => {
    if(target && target.type && chemical){
      // fields truck
      if(target.type === LAB_ORDER_TYPE.TRUCK){

        form.setFieldsValue({
          main : CHEMICAL.RAW_LATEX
        })
      }
      // fields pond
      if(target.type === LAB_ORDER_TYPE.POND){
        form.setFieldsValue({
          main : CHEMICAL.POND,
          fill : _.filter(chemical, { 'pond': true }),
        })
      }

      if(target.type === LAB_ORDER_TYPE.TANK){
        form.setFieldsValue({
          main : CHEMICAL.TANK,
          fill : _.filter(chemical, { 'tank': true }),
        })
      }

      // fields skim
      if(target.type === LAB_ORDER_TYPE.SKIM){

        form.setFieldsValue({
          main : CHEMICAL.SKIM
        })
      }

      if(target.type === LAB_ORDER_TYPE.TANK){
        setwidthModal(850);
      } else {
        setwidthModal(700);
      }

      const additional = _.filter(chemical, { 'tank': false, 'pond': false }).map((item) => {
        return { label : item.name, value : item.name, key : item.id }
      })
      setAdditionalChemical(additional)

    }
    
  },[chemical])

  React.useEffect(() => {
    if(target)
      fetchChemical()
  },[target])

  React.useEffect(() => {
    setErrorMessages(null)
  },[open])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      onOk={handleOk}
      okText={"ยืนยัน"}
      cancelText={"ปิด"}
      width={widthModal}
      destroyOnClose={true}
      title={`${_.get(LAB_ORDER_TYPE_TH, _.get(target, 'type', ''), 'ผลแล็ป')} - ${_.get(target, 'code', '')}`} 
      okButtonProps={{ style: { backgroundColor : PRIMARY_COLOR}}}
      centered={true}
    >
    <ErrorMessages message={errorMessages} style={{ marginTop : 0, marginBottom : 12}}/>
    {isCreate && 
      <Form
          form={formWeight}
          style={{ marginLeft : 20}}
        >
        <Row>
          <Col span={12}>
            <Form.Item 
              name={'original_weight'}
              label={'น้ำหนัก (Kg)'}
              rules={[{ required: true, message: 'กรุณากรอกน้ำหนัก!' }]}
              style={{marginRight : 20}}
            >
              <InputNumber placeholder="น้ำหนัก" style={{ width : '100%'}} precision={0}/>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item 
              name={'original_height'}
              label={'ความสูง (Cm)'}
              rules={[{ required: true, message: 'กรุณากรอกความสูง!' }]}
              style={{marginRight : 18}}
            >
              <InputNumber 
                autoComplete="off" 
                style={{ width : '95%', marginLeft : 5 }} 
                placeholder="ส่วนสูง" 
                onChange={(value) => formWeight.setFieldValue('original_weight', Math.round(value * target.weight_per_height))}
                onPressEnter={(e) => !weightWatch ? formWeight.setFieldValue('original_weight', (e.target.value * target.weight_per_height)) : null} 
              />
          </Form.Item>
          </Col>
        </Row>
        <Divider/>
      </Form>
    }
    <Form
      form={form}
      style={{ marginLeft : 20}}
    >
      <div style={{ fontWeight: 'bolder' , fontSize : 16, marginBottom : 12 }}>{"ผลแล็บ"}</div>
      <Row>
      {/* ผลตรวจสารเคมี */}
      <Form.List name="main"  >
        {(fields) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Col span={ _.get(target, 'type', null) === LAB_ORDER_TYPE.POND ? 12 : _.get(target, 'type', null) === LAB_ORDER_TYPE.TANK ? 8 : 12}>
                <Row>
                  <Form.Item>
                    <span style={{ display: 'inline-block' , width: '60px' }}>{`${form.getFieldValue(['main', name, 'chemical'])} : `}</span>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'amount']}
                  >
                    <InputNumber placeholder="จำนวน" style={{ width : 160}}/>
                  </Form.Item>
                </Row>
              </Col>
            ))}
          </>
        )}
      </Form.List>
      </Row>

      {/* เพิ่มสารเคมีผล */}
      {/* {_.get(target, 'type', null) === LAB_ORDER_TYPE.TRUCK && <Form.List name="more">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => (
              <Space
                key={key}
                style={{
                  display: 'flex',
                  marginBottom: 5,
                }}
                align="baseline"
              >
                <span style={{ display: 'inline-block', width: '60px' }}>อื่นๆ : </span>
                <Form.Item
                  {...restField}
                  name={[name, 'chemical']}
                  rules={[
                    {
                      required: true,
                      message: 'กรุณาเลือกสารเคมี'
                    },
                  ]}
                >
                  <Select
                    showSearch
                    style={{ width : 190}} 
                    placeholder={'สารเคมี'} 
                    options={_.filter(chemical, { 'pond': false, 'tank': false })}
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                  />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'amount']}
                  rules={[
                    {
                      required: true,
                      message: 'กรุณากรอกจำนวน'
                    },
                  ]}
                >
                  <InputNumber placeholder="จำนวน" style={{ width : 190}}/>
                </Form.Item>
                <MinusCircleOutlined onClick={() => remove(name)} />
              </Space>
            ))}
            <Form.Item>
              <ColorButton type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                เพิ่มผลตรวจ
              </ColorButton>
            </Form.Item>
          </>
        )}
      </Form.List>} */}

      {/* เติมสารเคมี */}
      {(_.get(target, 'type', null) === LAB_ORDER_TYPE.POND || _.get(target, 'type', null) === LAB_ORDER_TYPE.TANK ) && 
        <>
          <Divider/>
          <div style={{ fontWeight: 'bolder' , fontSize : 16, marginBottom : 12 }}>{"สั่งเติมสารเคมี"}</div>
          <Row>
          <Form.List name="fill">
            {(fields) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  // <Col span={ _.get(target, 'type', null) === LAB_ORDER_TYPE.POND ? 12 : _.get(target, 'type', null) === LAB_ORDER_TYPE.TANK ? 8 : 24}>
                    <Col span={12}>
                    <Row>
                      <Form.Item>
                        <span style={{ display: 'inline-block' , width: '130px' }}>{`${form.getFieldValue(['fill', name, 'name'])} : `}</span>
                      </Form.Item>
                      <Form.Item
                        {...restField}
                        name={[name, 'amount']}
                      >
                        <InputNumber placeholder="จำนวน" style={{ width : 150}}/>
                      </Form.Item>
                    </Row>
                  </Col>
                ))}
              </>
            )}
          </Form.List>
          </Row>

          {/* เพิ่มสารเคมีเติม */}
          <Form.List name="fill_more">
            {(fields, { add, remove }) => (
              <>
                {fields.map(({ key, name, ...restField }) => (
                  <Space
                    key={key}
                    style={{
                      display: 'flex',
                      marginBottom: 5,
                    }}
                    align="baseline"
                  >
                    <span style={{ display: 'inline-block', width: '60px' }}>อื่นๆ : </span>
                    <Form.Item
                      {...restField}
                      name={[name, 'chemical']}
                      rules={[
                        {
                          required: true,
                          message: 'กรุณาเลือกสารเคมี'
                        },
                      ]}
                    >
                      <Select
                        showSearch
                        style={{ width : 190}} 
                        placeholder={'สารเคมี'} 
                        options={additionalChemical} 
                        filterOption={(input, option) =>
                          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }
                      />
                    </Form.Item>
                    <Form.Item
                      {...restField}
                      name={[name, 'amount']}
                      rules={[
                        {
                          required: true,
                          message: 'กรุณากรอกจำนวน'
                        },
                      ]}
                    >
                      <InputNumber placeholder="จำนวน" style={{ width : 190}}/>
                    </Form.Item>
                    <MinusCircleOutlined onClick={() => remove(name)} />
                  </Space>
                ))}
                <Form.Item>
                  <ColorButton type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                    เพิ่มสารเคมี
                  </ColorButton>
                </Form.Item>
              </>
            )}

          </Form.List>
        </>
      }

      {employeeConfig && 
        <>
          <Divider/>
          <div style={{ fontWeight: 'bolder' , fontSize : 16, marginBottom : 12 }}>{"ผู้ตรวจ"}</div>
          <Form.Item
            rules={[{ required: true, message : 'กรุณากรอกข้อมูล' }]}
            name="pin"
            style={{ width: "100%", alignItems: 'center',  justifyContent: 'center', display: 'flex' }}
          >
            <Space.Compact block style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex' }}>
              <Input style={{ width: 200, backgroundColor : "#FAFAFA" }} value={employee ? employee.name : '-'} readOnly/>
              <Input ref={pinRef} style={{ width: 170 }} placeholder="PIN" onPressEnter={(e) => handleValidateEmployee(e.target.value)}/>
              <ColorButton icon={<SearchOutlined/>} onClick={(e) => handleValidateEmployee(pinRef.current ? pinRef.current.input.value : '')}/>
            </Space.Compact>
          </Form.Item>
        </>
      }

      </Form>
      
      <ConfirmLabResultsModal
        open={resultsConfirmData ? true : false}
        target={target}
        data={resultsConfirmData}
        onClose={() => {
          setResultsConfirmData(null);
        }}
        onUpdate={() => {
          setResultsConfirmData(null);
          onUpdate();
        }}
      />
    </Modal>
  )
}